module.exports = __webpack_public_path__ + "media/show-crumbs.fb864f5e.mp4";